import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";

const StyledStack = styled(Stack).attrs({
    alignItems: "center",
    justifyContent: "center",
    height: "36px",
    width: "100%",
    marginTop: "70px",
})`
    background: ${({ theme }) => theme.palette.warning.light};
    color: ${({ theme }) => theme.palette.background.default};
    z-index: 1;
`;

const DemoBar = ({ children }) => {
    return (
        <StyledStack>
            <div>{children}</div>
        </StyledStack>
    );
};

export default DemoBar;
